import React from "react";
import styles from "./CourseInfoForm.module.scss";

interface CourseInfoFormProps {
    data: {
        title: string;
        author: string;
        price: string;
        discount: string;
    };
    onChange: (field: string, value: string) => void;
}

export const CourseInfoForm: React.FC<CourseInfoFormProps> = ({ data, onChange }) => {
    const handlePriceChange = (field: 'price' | 'discount', value: string) => {
        let sanitized = value.replace(/[^0-9.]/g, '');
        const parts = sanitized.split('.');
        if (parts.length > 2) {
            sanitized = parts[0] + '.' + parts[1];
        }
        if (parts[1]?.length > 2) {
            sanitized = parts[0] + '.' + parts[1].slice(0, 2);
        }
        onChange(field, sanitized);
    };

    const price = parseFloat(data.price) || 0;
    const discount = parseFloat(data.discount) || 0;
    const hasDiscountError = discount > price;

    return (
        <div>
            <div className={styles.formWrapper}>
                <h2 className={styles.label}>Информация о курсе</h2>

                <div className={styles.inputGroup}>
                    <label className={styles.inputLabel}>Название курса</label>
                    <input
                        type="text"
                        placeholder="Введите название курса..."
                        className={styles.input}
                        value={data.title}
                        onChange={e => onChange('title', e.target.value)}
                    />
                </div>

                <div className={styles.inputGroup}>
                    <label className={styles.inputLabel}>Автор курса</label>
                    <input
                        type="text"
                        placeholder="Введите автора курса..."
                        className={styles.input}
                        value={data.author}
                        onChange={e => onChange('author', e.target.value)}
                    />
                </div>

                <div className={styles.doubleInputGroup}>
                    <div className={styles.singleInputWrapper}>
                        <label className={styles.inputLabel}>Цена, ₽</label>
                        <input
                            type="text"
                            placeholder="Введите сумму в рублях..."
                            className={styles.input}
                            value={data.price}
                            onChange={e => handlePriceChange('price', e.target.value)}
                        />
                    </div>
                    <div className={styles.singleInputWrapper}>
                        <label className={styles.inputLabel}>Сумма скидки, ₽</label>
                        <input
                            type="text"
                            placeholder="Введите сумму в рублях..."
                            className={`${styles.input} ${hasDiscountError ? styles.inputError : ''}`}
                            value={data.discount}
                            onChange={e => handlePriceChange('discount', e.target.value)}
                        />
                        {hasDiscountError && (
                            <p className={styles.errorMessage}>
                                Сумма скидки не может быть больше цены
                            </p>
                        )}
                    </div>
                </div>
            </div>
            <div className={styles.headerLine}></div>
        </div>
    );
};
